export default __webpack_public_path__ + "static/media/orchid.c473ef5b.jpg";